/**
 * Student competition page: countdowns, date-gated operations, the codon cipher,
 * the horizontal timeline, and the mission-essentials disclosure.
 */

// Standard genetic code, used by the operation briefings' cipher.
var CODON = {
    UUU: 'F', UUC: 'F', UUA: 'L', UUG: 'L', CUU: 'L', CUC: 'L', CUA: 'L', CUG: 'L',
    AUU: 'I', AUC: 'I', AUA: 'I', AUG: 'M', GUU: 'V', GUC: 'V', GUA: 'V', GUG: 'V',
    UCU: 'S', UCC: 'S', UCA: 'S', UCG: 'S', CCU: 'P', CCC: 'P', CCA: 'P', CCG: 'P',
    ACU: 'T', ACC: 'T', ACA: 'T', ACG: 'T', GCU: 'A', GCC: 'A', GCA: 'A', GCG: 'A',
    UAU: 'Y', UAC: 'Y', CAU: 'H', CAC: 'H', CAA: 'Q', CAG: 'Q',
    AAU: 'N', AAC: 'N', AAA: 'K', AAG: 'K', GAU: 'D', GAC: 'D', GAA: 'E', GAG: 'E',
    UGU: 'C', UGC: 'C', UGG: 'W', CGU: 'R', CGC: 'R', CGA: 'R', CGG: 'R',
    AGU: 'S', AGC: 'S', AGA: 'R', AGG: 'R', GGU: 'G', GGC: 'G', GGA: 'G', GGG: 'G',
    UAA: ' ', UAG: ' ', UGA: ' ',
};

function pad(n) {
    return String(n).padStart(2, '0');
}

function paintClock(el, remaining) {
    var s = Math.max(0, remaining);
    var d = Math.floor(s / 86400);
    s -= d * 86400;
    var h = Math.floor(s / 3600);
    s -= h * 3600;
    var m = Math.floor(s / 60);
    s -= m * 60;

    var dEl = el.querySelector('[data-d]');
    var hEl = el.querySelector('[data-h]');
    var mEl = el.querySelector('[data-m]');
    var sEl = el.querySelector('[data-s]');
    if (dEl) { dEl.textContent = pad(d); }
    if (hEl) { hEl.textContent = pad(h); }
    if (mEl) { mEl.textContent = pad(m); }
    if (sEl) { sEl.textContent = pad(s); }
}

function missionTimers() {
    var clocks = document.querySelectorAll('[data-countdown]');
    var locked = document.querySelectorAll('.opcard--locked[data-unlock]');
    if (!clocks.length && !locked.length) { return; }

    var reloading = false;

    function tick() {
        var now = Date.now() / 1000;

        for (var i = 0; i < clocks.length; i++) {
            paintClock(clocks[i], Math.floor(+clocks[i].dataset.countdown - now));
        }

        // Locked cards never include briefing markup. When a countdown hits 00,
        // reload so PHP can render Unlock Briefing and the panel.
        if (document.body.dataset.gate !== 'live' || reloading) { return; }

        for (var g = 0; g < locked.length; g++) {
            var stamp = +locked[g].dataset.unlock;
            if (now < stamp) { continue; }
            var key = 'oo-op-reload-' + stamp;
            try {
                if (sessionStorage.getItem(key)) { continue; }
                sessionStorage.setItem(key, '1');
            } catch (err) {
                // Storage can be blocked; still reload once this visit.
            }
            reloading = true;
            location.reload();
            return;
        }
    }

    tick();
    setInterval(tick, 1000);
}

function cipher() {
    var boxes = document.querySelectorAll('[data-cipher]');

    for (var i = 0; i < boxes.length; i++) {
        (function (box) {
            var code = box.querySelector('[data-code]');
            var button = box.querySelector('[data-decrypt]');
            if (!code || !button) { return; }

            var rawHtml = code.innerHTML;
            var lines = code.querySelectorAll('.cline');
            var joined = [];
            for (var k = 0; k < lines.length; k++) { joined.push(lines[k].textContent.trim()); }

            var stream = joined
                .join(' ')
                .split(/\s+/)
                .map(function (c) {
                    var key = c.toUpperCase().replace(/T/g, 'U');
                    return CODON[key] === undefined ? '?' : CODON[key];
                })
                .join('');

            var phrases = stream.split(' ').filter(Boolean);
            var plainHtml = phrases
                .map(function (p) {
                    return '<span class="cline">' + p + '</span>';
                })
                .join('');

            var on = false;
            button.addEventListener('click', function () {
                on = !on;
                button.setAttribute('aria-pressed', on ? 'true' : 'false');
                button.textContent = on ? 'Re-encrypt' : 'Decrypt';
                if (on) { box.setAttribute('data-decoded', ''); }
                else { box.removeAttribute('data-decoded'); }
                code.innerHTML = on ? plainHtml : rawHtml;
            });
        })(boxes[i]);
    }
}

function timeline() {
    var cards = document.querySelectorAll('[data-tscroll]');

    for (var i = 0; i < cards.length; i++) {
        (function (card) {
            var track = card.querySelector('[data-track]');
            var nav = card.parentElement.querySelector('.tnav');
            if (!track || !nav) { return; }

            var fill = nav.querySelector('[data-tfill]');
            var prev = nav.querySelector('[data-tprev]');
            var next = nav.querySelector('[data-tnext]');

            function step() {
                var cols = track.children;
                return cols[1] ? cols[1].offsetLeft - cols[0].offsetLeft : track.clientWidth * 0.8;
            }

            if (prev) {
                prev.addEventListener('click', function () {
                    track.scrollBy({ left: -step(), behavior: 'smooth' });
                });
            }
            if (next) {
                next.addEventListener('click', function () {
                    track.scrollBy({ left: step(), behavior: 'smooth' });
                });
            }

            function sync() {
                var max = track.scrollWidth - track.clientWidth;
                var frac = track.clientWidth / Math.max(1, track.scrollWidth);
                var pos = max > 0 ? track.scrollLeft / max : 0;
                var width = Math.max(8, frac * 100);
                if (fill) {
                    fill.style.width = width + '%';
                    fill.style.left = pos * (100 - width) + '%';
                }
                if (prev) { prev.disabled = track.scrollLeft < 4; }
                if (next) { next.disabled = track.scrollLeft > max - 4; }
                nav.hidden = max < 4;
            }

            var timer;
            track.addEventListener(
                'scroll',
                function () {
                    clearTimeout(timer);
                    timer = setTimeout(sync, 50);
                },
                { passive: true }
            );
            addEventListener('resize', sync);
            sync();
        })(cards[i]);
    }
}

function disclosures() {
    var questions = document.querySelectorAll('.essq');
    for (var i = 0; i < questions.length; i++) {
        (function (button) {
            button.addEventListener('click', function () {
                button.setAttribute('aria-expanded', button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
            });
        })(questions[i]);
    }

    var toggles = document.querySelectorAll('[data-op-toggle]');
    var calm = matchMedia('(prefers-reduced-motion:reduce)').matches;
    for (var k = 0; k < toggles.length; k++) {
        (function (button) {
            var card = button.closest('.opcard');
            var dec = card && card.querySelector('.opdec');
            var label = dec && dec.querySelector('.odtx');
            var busy = false;
            button.addEventListener('click', function () {
                var panel = document.getElementById(button.getAttribute('aria-controls'));
                if (!panel || busy) { return; }
                var open = button.getAttribute('aria-expanded') === 'true';
                if (open) {
                    button.setAttribute('aria-expanded', 'false');
                    panel.hidden = true;
                    if (dec) { dec.classList.remove('is-dropping', 'is-unlocked', 'is-gone'); }
                    if (label) { label.textContent = 'Transmission decrypted'; }
                    return;
                }
                if (!dec || calm) {
                    if (dec) { dec.classList.add('is-unlocked', 'is-gone'); }
                    if (label) { label.textContent = 'Briefing unlocked!'; }
                    button.setAttribute('aria-expanded', 'true');
                    panel.hidden = false;
                    return;
                }
                busy = true;
                dec.classList.add('is-dropping');
                setTimeout(function () {
                    if (label) { label.textContent = 'Briefing unlocked!'; }
                    dec.classList.add('is-unlocked');
                    setTimeout(function () {
                        dec.classList.add('is-gone');
                        button.setAttribute('aria-expanded', 'true');
                        panel.hidden = false;
                        busy = false;
                    }, 950);
                }, 720);
            });
        })(toggles[k]);
    }
}

function timelinePhases() {
    var cols = document.querySelectorAll('[data-phase]');
    if (!cols.length) { return; }

    function mark() {
        var now = Date.now() / 1000;
        for (var i = 0; i < cols.length; i++) {
            var col = cols[i];
            var live = now >= +col.dataset.from && now < +col.dataset.to;
            col.classList.toggle('tcol--now', live);
            col.classList.toggle('tcol--done', now >= +col.dataset.to);
            if (live) { col.setAttribute('aria-current', 'step'); }
            else { col.removeAttribute('aria-current'); }
        }
    }

    mark();
    setInterval(mark, 60000);
}

function briefingUnlock() {
    var boxes = document.querySelectorAll('[data-unlock]');
    for (var i = 0; i < boxes.length; i++) {
        (function (box) {
            var button = box.querySelector('[data-unlock-btn]');
            var play = box.querySelector('.vplay');
            var sealed = box.querySelector('.vtx');
            if (!button || !play) { return; }

            button.addEventListener('click', function () {
                box.setAttribute('data-open', '');
                button.hidden = true;
                if (sealed) { sealed.hidden = true; }
                play.hidden = false;
                play.focus();
            });
        })(boxes[i]);
    }

    var scheduled = document.querySelectorAll('[data-open-from]');
    for (var k = 0; k < scheduled.length; k++) {
        if (Date.now() / 1000 < +scheduled[k].dataset.openFrom) { scheduled[k].hidden = true; }
    }
}

export default function competition() {
    missionTimers();
    cipher();
    timeline();
    disclosures();
    briefingUnlock();
    timelinePhases();
}
